import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "row bt-dash" }
const _hoisted_2 = { class: "col-12 p-0" }
const _hoisted_3 = {
  class: "w-100 table",
  style: {"border-collapse":"collapse"}
}
const _hoisted_4 = { class: "d-flex justify-content-center align-items-center gap-2 form-check checkbox-checked" }
const _hoisted_5 = ["id", "onUpdate:modelValue"]
const _hoisted_6 = ["for"]
const _hoisted_7 = ["onUpdate:modelValue"]
const _hoisted_8 = ["onUpdate:modelValue"]
const _hoisted_9 = ["onUpdate:modelValue"]

import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'productPriceLevels',
  setup(__props) {

const priceLevels = ref(
    Array.from({ length: 3 }, (_, i) => ({
        id: `${i + 1}`,
        Level: false,
        price: 0,
        halo: 0,
        lalo: 0,
    }))
);

const addPriceLevel = () => {
    const newId = priceLevels.value.length + 1;
    priceLevels.value.push({
        id: `${newId}`,
        Level: false,
        price: 0,
        halo: 0,
        lalo: 0,
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", { class: "text-center" }, "Level"),
            _createElementVNode("th", null, "Price"),
            _createElementVNode("th", null, "HALO"),
            _createElementVNode("th", null, "LALO")
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(priceLevels.value, (priceLevel) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: priceLevel.id
            }, [
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_4, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: `checkbox-${priceLevel.id}`,
                    "onUpdate:modelValue": ($event: any) => ((priceLevel.Level) = $event),
                    class: "form-check-input"
                  }, null, 8, _hoisted_5), [
                    [_vModelCheckbox, priceLevel.Level]
                  ]),
                  _createElementVNode("label", {
                    for: `checkbox-${priceLevel.id}`,
                    style: {"margin-top":"12px"}
                  }, _toDisplayString(priceLevel.id) + ".", 9, _hoisted_6)
                ])
              ]),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  class: "w-100",
                  type: "number",
                  "onUpdate:modelValue": ($event: any) => ((priceLevel.price) = $event)
                }, null, 8, _hoisted_7), [
                  [_vModelText, priceLevel.price]
                ])
              ]),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  class: "w-100",
                  type: "number",
                  "onUpdate:modelValue": ($event: any) => ((priceLevel.halo) = $event)
                }, null, 8, _hoisted_8), [
                  [_vModelText, priceLevel.halo]
                ])
              ]),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  class: "w-100",
                  type: "number",
                  "onUpdate:modelValue": ($event: any) => ((priceLevel.lalo) = $event)
                }, null, 8, _hoisted_9), [
                  [_vModelText, priceLevel.lalo]
                ])
              ])
            ]))
          }), 128)),
          _createElementVNode("tr", { class: "hover-shadow" }, [
            _createElementVNode("td", {
              colspan: "4",
              class: "text-center hover-pointer",
              onClick: addPriceLevel
            }, _cache[0] || (_cache[0] = [
              _createElementVNode("h5", null, "Add Price Level +", -1)
            ]))
          ])
        ])
      ])
    ])
  ]))
}
}

})